import type { FontScaleId } from '@/types';

/**
 * Multiplier applied to the root `<html>` font-size (16px) via the
 * `--app-font-scale` CSS custom property. Since every Mantine size token is
 * `rem`-based, scaling the root font-size scales the whole app
 * proportionally (spacing derived from `rem` too, so layout stays
 * consistent — only text and rem-based sizing grow/shrink).
 *
 * Note: `regular` is the default preference, but it is deliberately *not*
 * a 1:1 unscaled baseline — the step size between tiers increases toward
 * the top of the range so each option feels like a clearly noticeable jump.
 */
export const FONT_SCALE_MULTIPLIERS: Record<FontScaleId, number> = {
  smaller: 0.85,
  small: 1.0,
  regular: 1.2,
  large: 1.45,
  larger: 1.75,
};

export const FONT_SCALE_ORDER: FontScaleId[] = ['smaller', 'small', 'regular', 'large', 'larger'];

export const DEFAULT_FONT_SCALE_ID: FontScaleId = 'regular';
